var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownSm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.00004 9.99309C5.99775 10.2558 6.09876 10.5088 6.28129 10.6977L11.2915 15.7067C11.4795 15.8945 11.7343 16 12 16C12.2657 16 12.5205 15.8945 12.7085 15.7067L17.7187 10.6977C17.9012 10.5088 18.0022 10.2558 18 9.99309C17.9977 9.73042 17.8923 9.47916 17.7065 9.29342C17.5207 9.10768 17.2694 9.00232 17.0067 9.00004C16.7439 8.99776 16.4908 9.09873 16.3018 9.28121L12 13.5819L10.9979 12.5801L7.69819 9.28121C7.5092 9.09873 7.25608 8.99776 6.99335 9.00004C6.73061 9.00232 6.47928 9.10768 6.29349 9.29342C6.10771 9.47916 6.00232 9.73042 6.00004 9.99309Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownSm);
export default __webpack_public_path__ + "static/media/down-sm.f9096a76db5d597d19cdf0d67692c8f8.svg";
export { ForwardRef as ReactComponent };